<template>
    <div class="d-flex" v-if="!small">
        <label class="checkbox-container">
            <input type="checkbox" :checked="shouldBeChecked" @change="updateInput">
            <span class="checkmark"></span>
        </label>
        <div class="text-sm align-self-center text-start cursor-pointer" @click="updateInput"><slot></slot></div>
    </div>
    <div class="form-check" v-else>
        <label class="form-check-label">
            <input class="form-check-input" type="checkbox" :checked="shouldBeChecked" @change="updateInput">
            <slot></slot>
        </label>
    </div>
</template>

<script>
    export default {
        name: 'Checkbox',
        props: {
            value: [ Array, Boolean ],
            modelValue: [ String, Number ],
            small: Boolean
        },
        computed: {
            shouldBeChecked() {
                if (this.value instanceof Array) {
                    return this.value.includes(this.modelValue)
                }
                return this.value === true || this.modelValue === true
            }
        },
        methods: {
            updateInput() {
                let isChecked = !this.shouldBeChecked

                if (this.value instanceof Array) {
                    let newValue = [...this.value]
                    if (isChecked) {
                        newValue.push(this.modelValue)
                    } else {
                        newValue.splice(newValue.indexOf(this.modelValue), 1)
                    }

                    this.$emit('input', newValue)
                }
                else {
                    this.$emit('input', !!isChecked)
                }
            }
        }
    }
</script>